export default {
    common: {
        email: 'メールアドレス',
        LoginBtn: 'ログイン',
        SignUpBtn: 'サインアップ',
        SubmitBtn: '送信',
        ExitBtn: '終了',
        LogoutBtn: 'ログアウト'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'メールに記載の認証コードをご確認ください。',
        VerificationCode: '認証コード'
    },
    header: {
        OrderHistory: '注文履歴',
        MYACCOUNT: 'マイアカウント',
        WelcomeBack: 'おかえりなさい'
    },
    detail: {
        TotalOrders: '注文合計',
        TotalProducts: '商品合計',
        WonderlandPoints: 'ワンダーランドポイント',
        APMCredits: 'APM積分',
        ExpireOn: '有効期間',
        NoAPMCredits: 'APM積分なし',
        CreditsLoading: '積分ロード中'
    },
    panel: {},
    entry: {
        Client: 'お客様',
        OrderDate: '注文日',
        DeliverDate: '配送日',
        Description: '説明',
        Total: '合計'
    },
    board: {
        Order: '注文',
        Date: '日付',
        Total: '合計'
    },
    order: {
        OrderID: '注文ID',
        PurchasePlace: '場所',
        PurchaseDate: '購入日',
        TotalPrice: '合計金額',
    },
    product: {
        Name: 'お名前',
        SKU: 'SKU',
        Size: 'サイズ',
        Quantity: '数量',
        Price: '価格',
        WarrantyUntil: '保証の有効期限',
    }
}


// WEBPACK FOOTER //
// ./src/locales/jp/index.js